import React from 'react';
import { clsx } from 'clsx';
import type { Client } from '../../types';

type PlanRow = NonNullable<Client['plans']>[number];

const TYPE_STYLES: Record<string, string> = {
  funeral: 'bg-violet-50 text-violet-900 ring-violet-200/80',
  memorial: 'bg-sky-50 text-sky-900 ring-sky-200/80',
  cremation: 'bg-orange-50 text-orange-900 ring-orange-200/80',
  premium: 'bg-amber-50 text-amber-900 ring-amber-200/80',
  basic: 'bg-slate-50 text-slate-800 ring-slate-200/80',
  default: 'bg-slate-50 text-slate-800 ring-slate-200/80'
};

function planTypeKey(plan: PlanRow | undefined): string {
  const t = (plan?.planTemplate as { planType?: string } | undefined)?.planType || plan?.planType || plan?.name || '';
  return String(t).toLowerCase();
}

export const ClientPlanChip: React.FC<{ client: Client; className?: string }> = ({ client, className }) => {
  const plans = client.plans || [];
  if (!plans.length) {
    return (
      <span
        className={clsx(
          'inline-flex max-w-[200px] items-center rounded-lg bg-slate-100 px-2.5 py-1 text-xs font-medium text-slate-500 ring-1 ring-slate-200/80',
          className
        )}
      >
        Sin plan
      </span>
    );
  }

  const primary = plans[0] as PlanRow & { status?: string };
  const name =
    (primary.planTemplate as { name?: string } | undefined)?.name || primary.name || 'Plan';
  const pType = planTypeKey(primary);
  const ringClass = TYPE_STYLES[pType] || TYPE_STYLES.default;
  const planStatus = String(primary.status || 'active').toLowerCase();

  return (
    <div className={clsx('flex flex-col gap-1', className)}>
      <span
        className={clsx(
          'inline-flex max-w-[220px] items-center rounded-lg px-2.5 py-1 text-xs font-semibold tracking-tight ring-1 ring-inset',
          ringClass
        )}
        title={name}
      >
        <span className="truncate">{name}</span>
      </span>
      <span className="text-[10px] font-medium uppercase tracking-wide text-slate-400">
        {planStatus === 'active' && 'Plan activo'}
        {planStatus === 'inactive' && 'Suspendido'}
        {planStatus === 'completed' && 'Finalizado'}
        {!['active', 'inactive', 'completed'].includes(planStatus) && planStatus}
      </span>
      {plans.length > 1 && (
        <span className="text-[10px] font-medium text-slate-400">+{plans.length - 1} adicional</span>
      )}
    </div>
  );
};
